import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, Phone, X } from "lucide-react";

const LINKS = [
  { label: "Start", href: "#start", testId: "nav-link-start" },
  { label: "Usługi", href: "#uslugi", testId: "nav-link-uslugi" },
  { label: "O nas", href: "#o-nas", testId: "nav-link-o-nas" },
  { label: "Kontakt", href: "#kontakt", testId: "nav-link-kontakt" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-40 transition-[background-color,border-color,backdrop-filter] duration-300 ${
        scrolled || open
          ? "border-b border-white/10 bg-black/60 backdrop-blur-xl"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 md:px-8">
        <a
          href="#start"
          data-testid="nav-logo"
          className="font-display text-base font-800 tracking-[0.18em] text-white md:text-lg"
          style={{ fontWeight: 800 }}
        >
          TRANSPORT <span className="text-[#E2C792]">OSÓB</span>
        </a>

        <nav className="hidden items-center gap-8 lg:flex" aria-label="Nawigacja główna">
          {LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={link.testId}
              className="group relative text-sm font-medium text-white/70 transition-colors duration-200 hover:text-white"
            >
              {link.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#E2C792] transition-[width] duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="tel:+48737473050"
            data-testid="header-call-button"
            className="hidden items-center gap-2 rounded-full bg-[#E2C792] px-6 py-3 text-sm font-bold tracking-wide text-[#0A0A0A] transition-[background-color,transform] duration-200 hover:bg-[#D1B273] active:scale-95 sm:inline-flex"
          >
            <Phone className="h-4 w-4" strokeWidth={2.5} />
            ZADZWOŃ
          </a>
          <button
            type="button"
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "Zamknij menu" : "Otwórz menu"}
            className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/10 bg-white/5 text-white transition-colors duration-200 hover:bg-white/10 lg:hidden"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
            className="overflow-hidden border-t border-white/10 bg-black/80 backdrop-blur-xl lg:hidden"
            aria-label="Nawigacja mobilna"
          >
            <div className="flex flex-col gap-1 px-5 py-4">
              {LINKS.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  data-testid={`mobile-${link.testId}`}
                  onClick={() => setOpen(false)}
                  className="rounded-lg px-3 py-3.5 font-display text-lg font-semibold text-white/80 transition-colors duration-200 hover:bg-white/5 hover:text-white"
                >
                  {link.label}
                </a>
              ))}
              <a
                href="tel:+48737473050"
                data-testid="mobile-menu-call-button"
                className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-[#E2C792] px-6 py-4 text-sm font-bold tracking-wide text-[#0A0A0A] active:scale-95"
              >
                <Phone className="h-4 w-4" strokeWidth={2.5} />
                ZADZWOŃ — 737 473 050
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
